import { FunctionComponent } from "react";
import { Button, IconButton, Input, Select } from '../../tailwindcomponents';
import { DatePicker } from '../../MaterialUiComponents';
import { Close } from '../icons';

type HandoverReportFiltersProps = {
    searchIssue: string,
    setSearchIssue: (value: string) => void,
    selectedTailNumber: string,
    setSelectedTailNumber: (value: string) => void,
    fromDate: Date | null,
    setFromDate: (value: Date | null) => void,
    toDate: Date | null,
    setToDate: (value: Date | null) => void,
    allTails: Array<string>,
    onFilter: () => void,
    onClearFilters: () => void,
}

/**
 * Tail / issue / date-range filter bar for the handover report list.
 *
 * Filtering runs server-side against GetHandoverBySearchFilters: the report list payload carries
 * no issues or tail numbers, so those two filters cannot be evaluated in the browser.
 *
 * Both dates start empty and are only sent when set. The original Line Planner version of this bar
 * defaulted them to today and always sent them, which silently limited every tail or issue search
 * to reports created today.
 */
const HandoverReportFilters: FunctionComponent<HandoverReportFiltersProps> = ({
    searchIssue,
    setSearchIssue,
    selectedTailNumber,
    setSelectedTailNumber,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    allTails,
    onFilter,
    onClearFilters,
}) => {
    return (
        <div className="ds-filter-bar">
            <Select
                width={100}
                widthPercentage
                filter_by_text="Tail number"
                onSelectedItem={(e: any) => setSelectedTailNumber(e?.target?.value ?? "")}
                options={allTails}
                selectedItem={selectedTailNumber}
            />
            <Input
                multiline={false}
                label_text="Search by issue"
                value={searchIssue}
                help_text=""
                onTextChange={(value: string) => setSearchIssue(value)}
                type="text"
                width={100}
                icon={
                    <IconButton onClick={() => setSearchIssue("")}>
                        <Close />
                    </IconButton>
                }
                iconPlacement="end"
            />
            <DatePicker
                type="Date"
                selected={fromDate}
                label="From"
                onDateChange={(date: Date | null) => setFromDate(date)}
            />
            <DatePicker
                type="Date"
                selected={toDate}
                label="To"
                onDateChange={(date: Date | null) => setToDate(date)}
            />
            <div className="ds-filter-actions">
                <Button variant="text" onClick={() => onFilter()} color="primary">
                    Filter
                </Button>
                <Button variant="text" onClick={() => onClearFilters()} color="primary">
                    Clear Filters
                </Button>
            </div>
        </div>
    );
}

export default HandoverReportFilters;
